import { render, staticRenderFns } from "./doubleScreen.vue?vue&type=template&id=f1550680&scoped=true&"
import script from "./doubleScreen.vue?vue&type=script&lang=js&"
export * from "./doubleScreen.vue?vue&type=script&lang=js&"
import style0 from "./doubleScreen.vue?vue&type=style&index=0&id=f1550680&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1550680",
  null
  
)

export default component.exports